var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"liveView"},[_c('video-player',{ref:"videoPlayer",staticClass:"vjs-custom-skin",attrs:{"options":_vm.playerOptions,"playsinline":_vm.playsinline},on:{"ready":_vm.onPlayerReadied,"timeupdate":_vm.onTimeupdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }